import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CardLinkOfferCategoriesStore, CardLinkOfferCategoriesState } from './card-link-offer-categories.store';

@Injectable({ providedIn: 'root' })
export class CardLinkOfferCategoriesQuery extends QueryEntity<CardLinkOfferCategoriesState> {

  constructor(protected store: CardLinkOfferCategoriesStore) {
    super(store);
  }

}
